export const PHONE = "825-462-0628";
export const PHONE_HREF = "tel:+18254620628";
export const SMS_HREF = "sms:+18254620628";
export const FORM_URL =
  "https://forms.zohopublic.com/claims2/form/WorkAuthorization2026/formperma/5MTfYwiW5lWb-O0ntUzHtnJS1wRxRgIasFpZBf9v7ms";

export const IMAGES = {
  heroUnderwater: "https://images.pexels.com/photos/5391865/pexels-photo-5391865.jpeg",
  causticDark:
    "https://images.unsplash.com/photo-1502626273240-f2a6694f5420?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  causticBright:
    "https://images.unsplash.com/photo-1587276548285-81f6152dc428?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  dryRoom: "https://images.pexels.com/photos/6738989/pexels-photo-6738989.jpeg?auto=compress&cs=tinysrgb&w=1400",
};

/** Smooth-scroll to the intake form. Uses Lenis when available, else native smooth. */
export const scrollToIntake = () => {
  const el = document.getElementById("intake");
  if (!el) return;
  if (typeof window !== "undefined" && window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -64, duration: 1.2 });
  } else {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }
};
